module.exports = __webpack_public_path__ + "img/chris (2).9aa6b692.jpg";